<template>
  <div class="p-friends">
    <section class="c-p-r friends-top">
      <div class="c-d-f c-fd-c c-ai-c c-p-c c-ta-c cm-width friends-top-desc">
        <p class="c-fs-38 c-c-text-color c-mb-32 c-fw-b top-title">猫维合作生态体系</p>
        <p class="c-c-text-color c-fs-16 c-ff-l c-mb-36 top-desc">加入猫维合作体系，为区域内最终用户提供技术服务和增值解决方案</p>
        <div class="c-visible-pc" v-if="$store.state.isPc">
          <div class="c-d-f c-ai-c">
            <button class="c-mr-8 c-ff-b c-btn-dark-156-nob">成为合作伙伴</button>
            <!-- <div class="c-d-f">
              <input v-model="inputVal" placeholder="查找合作伙伴资质及信息" class="friends-input">
              <button class="friends-btn" @click="searchPartner"><img src="../assets/friends/search.png"></button>
            </div> -->
          </div>
        </div>
        <div class="c-visible-mobile" v-if="!$store.state.isPc">
          <div class="c-d-f c-ai-c">
            <button class="c-mr-8 c-ff-b c-fs-15 c-btn-dark-124-nob">成为合作伙伴</button>
            <!-- <div class="c-d-f c-fs-13">
              <input v-model="inputVal" placeholder="查找合作伙伴资质及信息" class="friends-input">
              <button class="friends-btn" @click="searchPartner"><img src="../assets/friends/search.png"></button>
            </div> -->
          </div>
        </div>
      </div>
    </section>
    <section class="friends-wrap">
      <div class="cm-width area">
        <div class="">
          <div class="c-d-f c-ai-c c-jc-c section-title">
            <img src="../assets/index/icon.png" class="icon-m">
            <p class="c-mlr-12 c-c-text-blue">全面专业的业务支持</p>
            <img src="../assets/index/icon.png" class="icon-m">
          </div>
          <section class="production card">
            <div class="item">
              <img src="../assets/friends/icon2.svg">
              <div>
                <p class="title">培训支持</p>
                <div class="c-d-f c-ai-c c-mb-8">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">销售人员培训</p>
                </div>
                <div class="c-d-f c-ai-c c-mb-8">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">产品/服务培训</p>
                </div>
                <div class="c-d-f c-ai-c">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">续签技巧培训</p>
                </div>
              </div>
            </div>
            <div class="item">
              <img src="../assets/friends/icon4.svg">
              <div>
                <p class="title">销售支持</p>
                <div class="c-d-f c-ai-c c-mb-8">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">专业解决方案支持</p>
                </div>
                <div class="c-d-f c-ai-c c-mb-8">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">销售顾问支持</p>
                </div>
                <div class="c-d-f c-ai-c">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">成功销售模式复制</p>
                </div>
              </div>
            </div>
            <div class="item">
              <img src="../assets/friends/icon10.svg">
              <div>
                <p class="title">售前支持</p>
                <div class="c-d-f c-ai-c c-mb-8">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">现场支持</p>
                </div>
                <div class="c-d-f c-ai-c c-mb-8">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">远程支持</p>
                </div>
                <div class="c-d-f c-ai-c">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">商机辅导</p>
                </div>
              </div>
            </div>
            <div class="item">
              <img src="../assets/friends/icon5.svg">
              <div>
                <p class="title">物料支持</p>
                <div class="c-d-f c-ai-c c-mb-8">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">公司及产品宣传册</p>
                </div>
                <div class="c-d-f c-ai-c c-mb-8">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">宣传海报/易拉宝</p>
                </div>
                <div class="c-d-f c-ai-c">
                  <div class="c-mr-12 c-dot"></div>
                  <p class="desc">销售工具/合同模板</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <div class="c-bc-white area">
        <section class="cm-width">
          <div class="c-d-f c-ai-c c-jc-c section-title">
            <img src="../assets/index/icon.png" class="icon-m">
            <p class="c-mlr-12 c-c-text-blue">多样化营销支持</p>
            <img src="../assets/index/icon.png" class="icon-m">
          </div>
          <section class="fast card">
            <div class="item">
              <img src="../assets/friends/icon12.png">
              <div>
                <p class="title">资金支持</p>
                <p class="desc">联合举办市场活动，推广费用支持</p>
              </div>
            </div>
            <div class="item">
              <img src="../assets/friends/icon13.png">
              <div>
                <p class="title">营销工具支持</p>
                <p class="desc">宣传册、易拉宝、演讲PPT、视频等</p>
              </div>
            </div>
            <div class="item">
              <img src="../assets/friends/icon15.png">
              <div>
                <p class="title">人员支持</p>
                <p class="desc">营销活动策划与讲师支持</p>
              </div>
            </div>
          </section>
        </section>
      </div>

      <div class="area">
        <section class="cm-width">
          <div class="c-d-f c-ai-c c-jc-c section-title">
            <img src="../assets/index/icon.png" class="icon-m">
            <p class="c-mlr-12 c-c-text-blue">全程顾问式项目支持</p>
            <img src="../assets/index/icon.png" class="icon-m">
          </div>
          <section class="advantage card">
            <div class="item">
              <img src="../assets/friends/icon1.svg">
              <div>
                <p class="title">共同梳理客户资源</p>
              </div>
            </div>
            <div class="item">
              <img src="../assets/friends/icon7.svg">
              <div>
                <p class="title">针对性商机突破</p>
              </div>
            </div>
            <div class="item">
              <img src="../assets/friends/icon8.svg">
              <div>
                <p class="title">全过程销售支持与跟进</p>
              </div>
            </div>
            <div class="item">
              <img src="../assets/friends/icon9.svg">
              <div>
                <p class="title">全程运营/交付服务上线</p>
              </div>
            </div>
          </section>
        </section>
      </div>

      <!-- <section class="c-d-f c-mt-128 c-p-r contact">
        <div class="c-p-c cm-width">
          <div class="c-d-f c-fd-c c-ai-c c-ff-b">
            <p class="c-fs-38 c-mb-32 c-c-text-color contact-title">申请成为合作伙伴</p>
            <div class="c-d-f">
              <div class="c-d-f c-ai-c c-mb-12" style="background: blue">
                <img src="../assets/header/icon2.png">
                <span class="c-ml-20">4006-111-696</span>
              </div>
            </div>
          </div>
        </div>
      </section> -->

      <!-- <section class="c-visible-pc">
        <div class="c-d-f c-ai-c c-mt-80 c-mb-40" id="partnerLevel">
          <img src="../assets/index/icon.png">
          <span class="c-ml-12 c-c-text-color c-ff-m c-fs-24">合作伙伴级别</span>
        </div>
        <div class="level-wrap">
          <div class="c-d-f c-p-r">
            <div class="c-ta-l c-f-1 special-border-right level-item">
              <img src="../assets/friends/friends1.png">
              <p class="c-fs-20 c-mt-36 c-c-text-blue">分销商</p>
              <p class="c-fs-14 c-mt-16 c-c-text-grey c-ta-j c-lh-22">合作伙伴入门级别，仅负责各区域内Zabbix原厂服务的宣传和转售，无法提供原厂服务</p>
              <p class="c-fs-20 c-mt-36 c-c-text-blue">相关权益</p>
              <ul class="c-fs-14 c-mt-16 c-ml-20 c-c-text-grey c-ta-j c-lh-22">
                <li >分销商能够从转售每项服务收到的佣金中获得5%-25%的提成</li>
                <li class="c-mt-16">分销商购买Zabbix官方认证培训服务可以额外获得20%的合作伙伴专享折扣(ZCS&ZCP)</li>
              </ul>
            </div>
            <div class="line"></div>
            <div class="c-ta-l c-f-1 special-border level-item">
              <img src="../assets/friends/friends2.png">
              <p class="c-fs-20 c-mt-36 c-c-text-blue">认证合作伙伴</p>
              <p class="c-fs-14 c-mt-16 c-c-text-grey c-ta-j c-lh-22">除了宣传和转售Zabbix服务外，官方还授权认证合作伙伴提供部分Zabbix服务及解决方案</p>
              <p class="c-fs-20 c-mt-36 c-c-text-blue">相关权益</p>
              <ul class="c-fs-14 c-mt-16 c-ml-20 c-c-text-grey c-ta-j c-lh-22">
                <li >认证合作伙伴能够从转售服务收到的佣金中获取5%-30%的提成; 如果提供部分服务的话，将有机会获取高达60%的提成</li>
                <li class="c-mt-16">在向客户提供Zabbix支持服务时，能够购买和使用Zabbix原厂团队二线支持(second line support)作为更有效的保障支持</li>
              </ul>
            </div>
            <div class="line line1"></div>
            <div class="c-ta-l c-f-1 special-border-left level-item">
              <img src="../assets/friends/friends3.png">
              <p class="c-fs-20 c-mt-36 c-c-text-blue">高级合作伙伴</p>
              <p class="c-fs-14 c-mt-16 c-c-text-grey c-ta-j c-lh-22">认证合作伙伴通过1年的考核之后可以升级成为高级合作伙伴。作为Zabbix合作伙伴体系中的最高级别</p>
              <p class="c-fs-20 c-mt-36 c-c-text-blue">相关权益</p>
              <ul class="c-fs-14 c-mt-16 c-ml-20 c-c-text-grey c-ta-j c-lh-22">
                <li >分销商能够从转售每项服务收到的佣金中获得5%-25%的提成</li>
                <li class="c-mt-16">分销商购买Zabbix官方认证培训服务可以额外获得20%的合作伙伴专享折扣(ZCS&ZCP)</li>
              </ul>
            </div>
          </div>
          <div class="c-d-f c-jc-fe c-mt-28 c-ff-b">
            <button class="c-btn-156">查看更多相关权益</button>
            <button class="c-ml-12 c-btn-dark-156-nob">立即申请合作伙伴</button>
          </div>
        </div>
      </section>
      <section class="c-visible-mobile">
        <div class="c-d-f c-ai-c c-mt-40 c-mb-24" id="partnerLevel-m">
          <img src="../assets/index/icon.png" class="c-icon-mobile">
          <span class="c-ml-8 c-c-text-color c-ff-m c-fs-16">合作伙伴级别</span>
        </div>
        <div class="level-wrap-mobile">
          <div>
            <div class="c-d-f c-ta-l level-item-mobile">
              <img class="partner-img" src="../assets/friends/friends1.png">
              <div class="c-ml-20">
                <p class="c-fs-15 c-c-text-blue">分销商</p>
                <p class="c-fs-12 c-mt-12 c-c-text-grey c-ta-j c-lh-18">合作伙伴入门级别，仅负责各区域内Zabbix原厂服务的宣传和转售，无法提供原厂服务</p>
                <p class="c-fs-15 c-mt-20 c-c-text-blue">相关权益</p>
                <ul class="c-fs-12 c-mt-12 c-ml-20 c-c-text-grey c-ta-j c-lh-18">
                  <li >分销商能够从转售每项服务收到的佣金中获得5%-25%的提成</li>
                  <li class="c-mt-12">分销商购买Zabbix官方认证培训服务可以额外获得20%的合作伙伴专享折扣(ZCS&ZCP)</li>
                </ul>
              </div>
            </div>
            <div class="c-d-f c-mt-8 c-ta-l level-item-mobile">
              <img class="partner-img" src="../assets/friends/friends2.png">
              <div class="c-ml-20">
                <p class="c-fs-15 c-c-text-blue">认证合作伙伴</p>
                <p class="c-fs-12 c-mt-12 c-c-text-grey c-ta-j c-lh-18">除了宣传和转售Zabbix服务外，官方还授权认证合作伙伴提供部分Zabbix服务及解决方案</p>
                <p class="c-fs-15 c-mt-20 c-c-text-blue">相关权益</p>
                <ul class="c-fs-12 c-mt-12 c-ml-20 c-c-text-grey c-ta-j c-lh-18">
                  <li >认证合作伙伴能够从转售服务收到的佣金中获取5%-30%的提成; 如果提供部分服务的话，将有机会获取高达60%的提成</li>
                  <li class="c-mt-12">在向客户提供Zabbix支持服务时，能够购买和使用Zabbix原厂团队二线支持(second line support)作为更有效的保障支持</li>
                </ul>
              </div>
            </div>
            <div class="c-d-f c-mt-8 c-ta-l level-item-mobile">
              <img class="partner-img" src="../assets/friends/friends3.png">
              <div class="c-ml-20">
                <p class="c-fs-15 c-c-text-blue">高级合作伙伴</p>
                <p class="c-fs-12 c-mt-12 c-c-text-grey c-ta-j c-lh-18">认证合作伙伴通过1年的考核之后可以升级成为高级合作伙伴。作为Zabbix合作伙伴体系中的最高级别</p>
                <p class="c-fs-15 c-mt-20 c-c-text-blue">相关权益</p>
                <ul class="c-fs-12 c-mt-12 c-ml-20 c-c-text-grey c-ta-j c-lh-18">
                  <li>分销商能够从转售每项服务收到的佣金中获得5%-25%的提成</li>
                  <li class="c-mt-12">分销商购买Zabbix官方认证培训服务可以额外获得20%的合作伙伴专享折扣(ZCS&ZCP)</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="c-visible-pc">
            <div class="c-d-f c-jc-fe c-mt-28 c-ff-b">
              <button class="c-btn-156">查看更多相关权益</button>
              <button class="c-ml-12 c-btn-dark-156-nob">立即申请合作伙伴</button>
            </div>
          </div>
          <div class="c-visible-mobile">
            <div class="c-d-f c-jc-c c-mt-24 c-ff-b">
              <button class="c-btn-156">查看更多相关权益</button>
              <button class="c-ml-12 c-btn-dark-156-nob">立即申请合作伙伴</button>
            </div>
          </div>
        </div>
      </section>
      <div class="c-visible-pc">
        <section class="c-d-f c-mt-80 c-mb-164 c-bc-white map-wrap" id="partnerMap">
          <div class="map-desc">
            <div class="c-d-f c-ai-c">
              <img src="../assets/index/icon.png">
              <span class="c-ml-12 c-c-text-color c-ff-m c-fs-24">合作伙伴地图</span>
            </div>
            <p class="c-fs-18 c-mt-16 c-c-text-color c-ta-j c-lh-38">目前Zabbix在全球范围内有超过181家合作伙伴，这个数字还在不断增长</p>
          </div>
          <div id="map-container" class="c-p-16 map-content">
          </div>
        </section>
      </div>
      <div class="c-visible-mobile">
        <section class="c-mt-40 c-mb-40 map-wrap-mobile" id='partnerMap-m'>
          <div class="map-desc">
            <div class="c-d-f c-mb-24 c-ai-c">
              <img src="../assets/index/icon.png" class="c-icon-mobile">
              <span class="c-ml-8 c-c-text-color c-ff-m c-fs-16">合作伙伴地图</span>
            </div>
            <p class="c-fs-12 c-c-text-grey c-ta-j c-lh-18">目前Zabbix在全球范围内有超过181家合作伙伴，这个数字还在不断增长</p>
          </div>
          <div class="c-bc-white c-mt-24 c-p-8">
            <div id="map-container-mobile" class="map-content"></div>
          </div>
        </section>
      </div> -->
      <!-- <div class="c-visible-pc">
        <section class="c-mt-80 c-mb-164 friends-list-wrap" id="partnerList">
          <div class="c-d-f c-jc-sb c-mb-40">
            <div class="c-d-f c-ai-c">
              <img src="../assets/index/icon.png">
              <span class="c-ml-12 c-c-text-color c-ff-m c-fs-24">合作伙伴列表</span>
            </div>
            <el-select v-model="selectValue" @change="selectFriendsType" placeholder="Select">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="c-d-f c-fw-w pic-list">
            <div class="c-cs-p partners-item" v-for="item in allPartnerList" :key="item.url">
              <img :src="item.url" @click="clickFriend(item.url)" class="svg">
            </div>
          </div>
        </section>
      </div> -->
      <!-- <section class="c-visible-mobile">
        <section class="partners-wrap-mobile" id="partnerList-m">
          <div class="c-mb-24 c-mt-40">
            <div class="c-d-f c-ai-c c-jc-c">
              <img class="c-icon-mobile" src="../assets/index/icon.png">
              <span class="c-ml-8 c-mr-8 c-fs-19 c-fw-b c-c-text-color-dark">合作伙伴</span>
              <img class="c-icon-mobile" src="../assets/index/icon.png">
            </div>
            <p class="c-ta-c c-fs-10 c-c-text-grey">PARTNERS</p>
          </div>
          <div class="partners-content-mobile">
            <swiper class="swiper" :options="swiperOption" ref="mySwiper4">
              <swiper-slide v-for="(item, index) in mobilePartnerList" :key="index">
                <div class="c-d-f c-fw-w c-mb-44">
                  <div class="partners-item" v-for="i in item" :key="i.name">
                    <img :src="i.url" class="svg-m">
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-pagination" id="swiper-pagination4" slot="pagination"></div>
            </swiper>
          </div>
        </section>
      </section> -->
    </section>
  </div>
</template>

<script>
import { mapConfig } from '../constants/map.constants'
import { allPartnerList, mobilePartnerList } from '../constants/partners.constants'

let Vue = {}
export default {
  name: 'partners',
  data () {
    return {
      options: [
        {
          value: 'Option1',
          label: '中国区总代理'
        }, {
          value: 'Option2',
          label: '分销商'
        }, {
          value: 'Option3',
          label: '认证合作伙伴'
        }
      ],
      selectValue: 'Option1',
      inputVal: '',
      allPartnerList: allPartnerList,
      mobilePartnerList: mobilePartnerList,
      swiperOption: {
        ...this.$store.state.swiperOptions,
        pagination: {
          el: '#swiper-pagination4',
          clickable: true
        },
        on: {
          click: function (e) {
            Vue.selectPartner(e.target.id)
          }
        }
      }
    }
  },
  methods: {
    clickFriend (index) {
    },
    selectFriendsType (value) {
    },
    searchPartner () {
    },
    creatMap () {
      /* global BMap BMAP_ANCHOR_TOP_RIGHT BMAP_NAVIGATION_CONTROL_LARGE BMAP_NAVIGATION_CONTROL_ZOOM */
      const map = new BMap.Map('map-container')
      const point = new BMap.Point(...mapConfig.centerPoint)
      map.centerAndZoom(point, 5)
      map.enableScrollWheelZoom(true)
      map.disableBizAuthLogo() // 关闭JSAPI商用授权挂件

      const opts = {
        type: BMAP_NAVIGATION_CONTROL_LARGE,
        anchor: BMAP_ANCHOR_TOP_RIGHT
      }
      map.addControl(new BMap.NavigationControl(opts))

      const markPoint = mapConfig.markPoint
      markPoint.forEach(item => {
        // const sContent =
        // "<img id='imgDemo' src='" + `${item.img}` + "'height='50'/>" +
        // '<p style="font-size: 16px; color: #142B83; margin-top: 8px;">' + `${item.company}` + '</p>' +
        // '<p style="font-size: 14px; color: #696F8C; margin-top: 5px;">' + `${item.address}` + '</p>' +
        // '<p style="font-size: 14px; color: #696F8C; margin-top: 5px;">' + `${item.phone}` + '</p>'

        const pointItem = new BMap.Point(...item.point)
        const marker = new BMap.Marker(pointItem)
        map.addOverlay(marker)

        // marker.addEventListener('click', function () {
        //   map.setZoom(14)
        //   map.panTo(pointItem)
        //   const info = {
        //     width: 300,
        //     height: 140,
        //     title: item.name,
        //     offset: new BMap.Size(0, -25)
        //   }
        //   const infoWindow = new BMap.InfoWindow(sContent, info)
        //   map.openInfoWindow(infoWindow, pointItem)

        //   // 图片加载完毕重绘infowindow
        //   // document.getElementById('imgDemo').onload = function () {
        //   //   // 防止在网速较慢，图片未加载时，生成的信息框高度比图片的总高度小，导致图片部分被隐藏
        //   //   infoWindow.redraw()
        //   // }
        // })
      })
    },
    creatMapMobile () {
      const map = new BMap.Map('map-container-mobile', { enableHighResolution: true })
      const point = new BMap.Point(...mapConfig.centerPoint)
      map.centerAndZoom(point, 5)
      // map.enableScrollWheelZoom(true) // 鼠标缩放
      map.disableBizAuthLogo() // 关闭JSAPI商用授权挂件

      const opts = {
        type: BMAP_NAVIGATION_CONTROL_ZOOM,
        anchor: BMAP_ANCHOR_TOP_RIGHT
      }
      map.addControl(new BMap.NavigationControl(opts))

      const markPoint = mapConfig.markPoint
      markPoint.forEach(item => {
        // const sContent =
        // "<img id='imgDemo' src='" + `${item.img}` + "' height='40'/>" +
        // '<p style="font-size: 14px; color: #142B83; margin-top: 5px;">' + `${item.company}` + '</p>' +
        // '<p style="font-size: 12px; color: #696F8C; margin-top: 5px;">' + `${item.address}` + '</p>' +
        // '<p style="font-size: 12px; color: #696F8C; margin-top: 5px;">' + `${item.phone}` + '</p>'

        const pointItem = new BMap.Point(...item.point)
        const marker = new BMap.Marker(pointItem)
        map.addOverlay(marker)

        // marker.addEventListener('click', function () {
        //   map.setZoom(12)
        //   map.panTo(pointItem)
        //   const info = {
        //     width: 180,
        //     height: 120,
        //     offset: new BMap.Size(0, -25)
        //   }
        //   const infoWindow = new BMap.InfoWindow(sContent, info)
        //   map.openInfoWindow(infoWindow, pointItem)
        // })
      })
    },
    selectPartner (id) {
      if (id) {
      }
    }
  },
  mounted () {
    Vue = this
    // this.creatMap()
    // this.creatMapMobile()
  }
}
</script>

<style lang="scss">
.p-friends {
  min-height: calc(100vh - 90px - 525px);
  .friends-top {
    height: 560px;
    background: url("../assets/friends/friends-top.jpg") no-repeat;
    background-size: cover;
    background-position-x: center;
    @media screen and (max-width: $max-width-standard) {
      height: 232px;
      background: url("../assets/friends/friends-top-m.jpg") no-repeat;
      background-size: cover;
      background-position-x: center;
      .top-title {
        font-size: 19px;
        margin-bottom: 12px;
      }
      .top-desc {
        width: 70%;
        font-size: 9px;
        line-height: 16px;
        margin-bottom: 15px;
      }
    }
    .friends-top-desc {
      .friends-input {
        width: 466px;
        height: 48px;
        text-indent: 20px;
        border: 1px solid $text-grey;
        border-radius: 4px 0 0 4px;
        @media screen and (max-width: $max-width-standard) {
          width: 162px;
          @media screen and (max-width: 350px) {
            width: 120px;
          }
          text-indent: 10px;
        }
        &:focus {
          border-color: $background-blue;
        }
      }
      .friends-btn {
        width: 60px;
        height: 48px;
        border-radius: 0 4px 4px 0;
        background: $background-blue;
        cursor: pointer;
        @media screen and (max-width: $max-width-standard) {
          width: 50px;
        }
        &:hover {
          background: $background-blue-dark;
        }
        img {
          width: 24px;
        }
      }
    }
  }
  .friends-wrap {
    .analysis {
      padding: 80px;
      .intro-item-text {
        width: 46%;
      }
      .intro-item-img {
        width: 48%;
        height: 360px;
        object-fit: cover;
      }
    }
    .area {
      padding-bottom: 30px;
      padding-top: 50px;
      .section-title {
        font-size: 24px;
        color: $text-blue;
        text-align: center;
        margin-top: 30px;
        margin-bottom: 20px;
        @media screen and (max-width: $max-width-standard) {
          font-size: 19px;
          margin-top: 0px;
          margin-bottom: 0px;
          .icon-m {
            width: 10px;
            height: 10px;
          }
        }
      }
    }
    .card {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      max-width: 1180px;
      margin-left: auto;
      margin-right: auto;
      &.production {
        .item {
          width: 90%;
          justify-content: flex-start;
          @media (min-width: $min-width-standard) {
            &.item {
              width: 45%;
              justify-content: center;
            }
          }
        }
      }
      &.advantage {
        .item {
          width: 90%;
          flex-direction: column;
          align-items: center;
          text-align: center;
          img {
            margin-right: 0;
            margin-bottom: 0px;
            width: 120px;
            height: 120px;
          }
          @media (min-width: $min-width-standard) {
            &.item {
              width: 24%;
              img {
                width: 160px;
                height: 160px;
                margin-bottom: 20px;
              }
            }
          }
        }
      }
      &.fast {
        .item {
          width: 90%;
          flex-direction: column;
          align-items: center;
          text-align: center;
          img {
            margin-right: 0;
            margin-bottom: 0px;
            width: 80px;
            height: 80px;
          }
          @media (min-width: $min-width-standard) {
            &.item {
              width: 30%;
              img {
                margin-bottom: 20px;
                width: 120px;
                height: 120px;
              }
            }
          }
        }
      }
      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 32px;
        padding: 30px 15px;
        margin: 10px auto;
        @media screen and (max-width: $max-width-standard) {
          padding: 15px 15px;
        }
        // &:hover {
        //   background: #fff;
        //   box-shadow: 0px 0px 34px 8px rgba(93, 102, 172, 0.2);
        // }
        @media (min-width: $min-width-standard) {
          &.item {
            margin: 10px 0;
          }
        }
        img {
          display: block;
          flex-shrink: 0;
          width: 160px;
          height: 160px;
          object-fit: contain;
          margin-right: 30px;
          @media screen and (max-width: $max-width-standard) {
            width: 100px;
            height: 100px;
          }
        }
        .title {
          font-size: 20px;
          margin-bottom: 15px;
          @media screen and (max-width: $max-width-standard) {
            font-size: 15px;
            margin-bottom: 8px;
          }
        }
        .desc {
          color: $text-grey;
          line-height: 22px;
          font-size: 14px;
          margin-bottom: 0;
          @media screen and (max-width: $max-width-standard) {
            font-size: 12px;
          }
        }
      }
    }
    .contact {
      height: 280px;
      @media screen and (max-width: $max-width-standard) {
        height: 192px;
        margin-top: 24px;
        .contact-title {
          font-size: 19px;
          margin-bottom: 15px;
        }
      }
      background: url("../assets/training/training-grey.png") no-repeat;
      background-size: cover;
    }
    // .level-wrap {
    //   .level-item {
    //     border-radius: 1px;
    //     padding: 44px 54px;
    //     background-color: white;
    //     transition: all 0.3s ease-in-out;
    //     &::before {
    //       content: "";
    //       width: 0;
    //       height: 4px;
    //       background: $orange;
    //       position: absolute;
    //       top: 0;
    //       left: 50%;
    //       transition: all 0.3s;
    //     }
    //     &:hover {
    //       box-shadow: 0 10px 25px 0 rgba(0, 31, 255, 0.05);
    //       transform: translateY(-16px);
    //       border: none;
    //     }
    //     &:hover::before {
    //       left: 0;
    //       width: 100%;
    //     }
    //   }
    //   .line {
    //     position: absolute;
    //     left: 392px;
    //     width: 1px;
    //     height: 100%;
    //     z-index: 9;
    //     background-color: #BBC9E9;
    //     &.line1 {
    //       left: 786px;
    //     }
    //   }
    // }
    // .level-wrap-mobile {
    //   .level-item-mobile {
    //     border-radius: 1px;
    //     padding: 24px;
    //     background-color: white;
    //     .partner-img {
    //       width: 47px;
    //       height: 47px;
    //       object-fit: contain;
    //     }
    //   }
    // }
    // .map-wrap {
    //   min-height: 440px;
    //   .map-desc {
    //     flex: 0.3;
    //     padding: 44px 54px;
    //     border-right: 1px solid #BBC9E9;
    //   }
    //   .map-content {
    //     flex: 0.7;
    //     margin: 16px;
    //   }
    // }
    // .map-wrap-mobile {
    //   width: 100%;
    //   .map-content {
    //     width: 100%;
    //     height: 70vh;
    //   }
    // }
    // .friends-list-wrap {
    //   .svg {
    //     position: absolute;
    //     left: 50%;
    //     top: 50%;
    //     transform:translate(-50%, -50%);
    //     max-width: 120px;
    //     max-height: 80px;
    //   }
    //   .pic-list {
    //     .partners-item {
    //       width: 25%;
    //       height: 162px;
    //       display: block;
    //       box-sizing: border-box;
    //       position: relative;
    //       border: 1px solid #D1D8E8;
    //       border-right: none;
    //       border-top: none;
    //       &::before {
    //         content: "";
    //         width: 100%;
    //         height: 4px;
    //         background: $orange;
    //         position: absolute;
    //         top: 0;
    //         display: none;
    //       }
    //       &:hover::before {
    //         display: block;
    //       }
    //       &:hover {
    //         background: white;
    //         box-shadow: 0 10px 25px 0 rgba(0, 31, 255, 0.05);
    //       }
    //       // .partners-img {
    //       //   width: 120px;
    //       //   height: 100px;
    //       //   object-fit: contain;
    //       // }
    //     }
    //     & .partners-item:nth-of-type(4n) {
    //       border-right: 1px solid #D1D8E8;
    //     }
    //     & .partners-item:nth-last-of-type(1) {
    //       width: calc(25% + 1px);
    //       border-right: 1px solid #D1D8E8;
    //     }
    //     & .partners-item:nth-of-type(1) {
    //       border-top: 1px solid #D1D8E8;
    //     }
    //     & .partners-item:nth-of-type(2) {
    //       border-top: 1px solid #D1D8E8;
    //     }
    //     & .partners-item:nth-of-type(3) {
    //       border-top: 1px solid #D1D8E8;
    //     }
    //     & .partners-item:nth-of-type(4) {
    //       border-top: 1px solid #D1D8E8;
    //     }
    //   }
    // }
    // .partners-wrap-mobile {
    //   .swiper {
    //     width: 100%;
    //     --swiper-theme-color: #FF8243; // 不能使用$orange
    //     .swiper-pagination, .swiper-pagination-bullets {
    //       bottom: 15px;
    //       .swiper-pagination-bullet {
    //         width: 20px;
    //         height: 3px;
    //         border-radius: 1.5px;
    //         margin: 0 4px;
    //         outline: none;
    //       }
    //       .swiper-pagination-bullet-active {
    //         width: 50px;
    //       }
    //     }
    //   }
    //   .partners-content-mobile {
    //     padding-bottom: 25px;
    //     .partners-item {
    //       width: calc(100% / 3);
    //       height: 81px;
    //       background: #FFFFFF;
    //       border: 1px solid #D1D8E8;
    //       border-right: none;
    //       position: relative;
    //       .svg-m {
    //         position: absolute;
    //         left: 50%;
    //         top: 50%;
    //         transform:translate(-50%, -50%);
    //         max-width: 60%;
    //         max-height: 40px;
    //       }
    //     }
    //     & .partners-item:nth-of-type(3) {
    //       border-right: 1px solid #D1D8E8;
    //     }
    //     & .partners-item:nth-of-type(6) {
    //       border-right: 1px solid #D1D8E8;
    //       border-top: none;
    //     }
    //     & .partners-item:nth-of-type(4) {
    //       border-top: none;
    //     }
    //     & .partners-item:nth-of-type(5) {
    //       border-top: none;
    //     }
    //     & .partners-item:nth-last-of-type(1) {
    //       // width: calc((100% / 3) + 1px);
    //       border-right: 1px solid #D1D8E8;
    //     }
    //   }
    // }
  }
}
</style>
